import { useEffect, useState, useSyncExternalStore, type ReactNode } from 'react'
import {
  DOCUMENTS_FAILED_EVENT, documentsStatus, loadDocuments, subscribeDocuments,
} from '../lib/userDocuments'

/** Draws the workspace once the person's own documents have come (the
 *  analysis library, saved views, map symbols, the overview layout; db/035),
 *  since every page reads them as it opens. If they cannot be loaded the
 *  workspace still draws, says so, and saves none of them (`serverStorage`
 *  refuses), so the person's settings are never overwritten by an empty
 *  start. A save that fails later is said too. */
export function WorkspaceReady({ children }: { children: ReactNode }) {
  const status = useSyncExternalStore(subscribeDocuments, documentsStatus, documentsStatus)
  const [saveError, setSaveError] = useState('')
  useEffect(() => { void loadDocuments() }, [])
  useEffect(() => {
    const failed = (event: Event) => setSaveError((event as CustomEvent<string>).detail)
    window.addEventListener(DOCUMENTS_FAILED_EVENT, failed)
    return () => window.removeEventListener(DOCUMENTS_FAILED_EVENT, failed)
  }, [])
  if (status === 'idle' || status === 'loading') return <div className="pad muted" role="status">Loading your workspace…</div>
  return <>
    {status === 'failed' && <p className="workspace-notice error" role="alert">
      Your saved analyses, views and layout could not be loaded, so changes to them are not saved. Reload the page to try again.</p>}
    {saveError && <p className="workspace-notice error" role="alert">{saveError}
      <button type="button" className="link" onClick={() => setSaveError('')}>Dismiss</button></p>}
    {children}
  </>
}
